import { SORT, SEARCH, CHANNELS, CAMPAIGNS_STATUS } from 'constants/FilterConstants';
import * as types from 'modules/campaigns/actionTypes';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'text' | 'channel' | 'sort' } FilterCampaignField */
/** @typedef {string | number | Array<string> | Array<number>} FilterValue */
/** @typedef {Record<FilterCampaignField, FilterValue>} CampaignsFiltersReducer */

const persistedFilters = getPersistedFilters()?.filters?.campaigns ?? {};

const emptyState = {
  [SEARCH]: null,
  [CHANNELS]: [],
  [CAMPAIGNS_STATUS]: [],
  [SORT]: 'createdOn,DESC',
};

/** @type {import("modules/global/reducers/filterSliceAdapter").FilterAdapter<CampaignsFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_CAMPAIGNS_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.SET_CAMPAIGNS_DASHBOARD_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_CAMPAIGNS_DASHBOARD_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_CAMPAIGNS_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
